<template>

	<section class="dashboard__nav">

		<section class="global-nav">

			<section class="logo">

				<a href="https://mad-ud-af-huset.naesbyhovedskov.dk/admin#/order"><img src="/images/naesbyhoved-skov-logo.svg" alt="Logo"></a>

			</section>

			<nav class="nav">

				<h3>Ordre</h3>

				<ul>
					<li><router-link :to="{name:'order'}"><i class="icon--sm fas fa-inbox"></i> Pakkeliste</router-link></li>
					<li><router-link :to="{name:'order.search'}"><i class="icon--sm fas fa-search"></i> Find ordre</router-link></li>
					<li><router-link :to="{name:'make-order-choice'}"><i class="icon--sm fas fa-book"></i> Opret ordre</router-link></li>
				</ul>

				<h3>Mad</h3>

				<ul>
					<li><router-link :to="{name:'product.index'}"><i class="icon--sm fas fa-shopping-bag"></i> Produkter</router-link></li>
					<li><router-link :to="{name:'option.index'}"><i class="icon--sm fas fa-tag"></i> Retter</router-link></li>
				</ul>

				<h3>Salg</h3>

				<ul>
					<li><router-link :to="{name:'stats'}"><i class="icon--sm fas fa-chart-bar"></i> Stats</router-link></li>
				</ul>

				<h3>Generelt</h3>

				<ul>
					<li><router-link :to="{name:'tag.index'}"><i class="icon--sm fas fa-certificate"></i> Allergener</router-link></li>
					<li><router-link :to="{name:'deliveryPoint.index'}"><i class="icon--sm fas fa-box"></i> Udleveringssteder</router-link></li>
					<li><router-link :to="{name:'coupon.index'}"><i class="icon--sm fas fa-ticket-alt"></i> Rabatkoder</router-link></li>
				</ul>

			</nav>

		</section>

	</section>

</template>

<script>
    export default {
        name: "mainmenu",
        methods: {
            logOut() {
                axios.post('/logout').then(() => {
                    location.reload();
                }).catch(() => {
                    location.reload();
                });
            },
        },
    }
</script>

<style scoped>

</style>
